export default __webpack_public_path__ + "static/media/menegement_icon.bc55abec.svg";